/// <amd-module name="Repos/Views/CreatePullRequest/Components/CreatePullRequestFilesTab" />
import * as React from "react";
import { ChangesContext } from "Repos/ChangesCommon/ChangesContext";
import { ChangesExplorerView } from "Repos/Changes/Components/ChangesExplorerView";
import { IChangeCollection } from "Repos/ChangesCommon/Contracts";
import { GitVersionDescriptor } from "Repos/Common/Contracts/Git";
import { IGitFilesService } from "Repos/Files/GitFilesService";
import { getGitNavigationService } from "Repos/ChangesCommon/ChangesNavigationService";
import { IVssPageContext } from "VSS/Platform/Context";
import { VssComponent } from "VSS/Platform/Layout";
import { Observer } from "VSSUI/Observer";
import { IPullRequestCreateInfo } from "../CreatePullRequestViewService";
import { getChangesForPath } from "Repos/Changes/Util";
import { Spinner } from "VSSUI/Spinner";
import * as Resources from "Repos/Views/CreatePullRequest/Resources";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export interface IFilesTabContentProps {
    createInfo: IPullRequestCreateInfo;
}

export class FilesTabContent extends VssComponent<IFilesTabContentProps> {
    public render() {
        const { createInfo } = this.props;

        return (
            <Observer changes={createInfo.changes}>
                {(props: { changes: IChangeCollection<GitVersionDescriptor> | undefined }) => {
                    return props.changes ? <FilesContent changes={props.changes} pageContext={this.context.pageContext} /> : null;
                }}
            </Observer>
        );
    }
}

interface IFilesContentProps {
    changes: IChangeCollection<GitVersionDescriptor>;
    pageContext: IVssPageContext;
}

export const FilesContent = (props: IFilesContentProps): JSX.Element => {
    const { changes, pageContext } = props;

    const filesService = pageContext.getService<IGitFilesService>("IGitFilesService");
    const navigationService = getGitNavigationService(pageContext);

    if (isFeatureFlagEnabled(pageContext, "WebAccess.PullRequest.LoadMoreFiles")) {
        return (
            <Observer changes={navigationService.getChanges()}>
                    {(selectionProps: { changes: IChangeCollection<GitVersionDescriptor> | undefined }) => {
                        if (!selectionProps.changes) {
                            return <Spinner />;
                        }
    
                        if (getChangesForPath(selectionProps.changes, "/").length === 0) {
                            return (
                                <MessageCard className="margin-16" severity={MessageCardSeverity.Info}>
                                    {Resources.NoChangesToMerge}
                                </MessageCard>
                            );
                        }
                        return (
                            <div className="flex-column flex-grow">
                                <ChangesContext.Provider value={{ filesService, navigationService }}>
                                    <ChangesExplorerView addDiffKeyboardShortcuts={true} changes={selectionProps.changes} />
                                </ChangesContext.Provider>
                            </div>
                        );
                    }}
            </Observer>
        );
    }

    return (
        <div className="flex-column flex-grow">
            <ChangesContext.Provider value={{ filesService, navigationService }}>
                <ChangesExplorerView addDiffKeyboardShortcuts={true} changes={changes} />
            </ChangesContext.Provider>
        </div>
    );
};
